import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapSettingMenu = React.lazy(function () {
    return import('../../bootstrap-components/components/BTSettingMenu');
});
var bootStrapSettingMenu = function (props) {
    return React.createElement(BootStrapSettingMenu, __assign({}, props));
};
var SettingMenu = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapSettingMenu(props);
            break;
        default:
            componentToDisplay = bootStrapSettingMenu(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
SettingMenu.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(SettingMenu);
//# sourceMappingURL=SettingMenu.js.map